define('middleware-set-user',['exports'], function (exports) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function () {
        return function (next) {
            return function (action) {

                if (action.type == 'SET_USER') {
                    var _action$user = action.user,
                        user = _action$user === undefined ? {} : _action$user;


                    action.fullName = user.firstName && user.lastName ? user.firstName + ' ' + user.lastName : '', action.roles = Array.isArray(user.roles) ? user.roles.map(function (role) {
                        return {
                            ID: role.id,
                            name: role.systemName ? role.systemName.toLowerCase() : ''
                        };
                    }) : [];
                }

                next(action);
            };
        };
    };
});
